import apiClient from '@/clients/apiClient';
import {
  mapFeedbackStats,
  mapFeedbackUser,
  normalizeFeedbackListResponse,
} from '@/constants/feedback';

const buildFeedbackQuery = (params = {}) => {
  const q = new URLSearchParams();
  const {
    page = 1,
    pageSize = 25,
    search = '',
    status = '',
    category = '',
    rating = '',
    triggerPoint = '',
    platform = '',
    from = '',
    to = '',
  } = params;

  q.set('page', page);
  q.set('pageSize', pageSize);
  if (search) q.set('search', search);
  if (status) q.set('status', status);
  if (category) q.set('category', category);
  if (rating !== '' && rating != null) q.set('rating', rating);
  if (triggerPoint) q.set('triggerPoint', triggerPoint);
  if (platform) q.set('platform', platform);
  if (from) q.set('from', from);
  if (to) q.set('to', to);

  return q.toString();
};

export const getFeedbackStats = (from = '', to = '') => {
  const q = new URLSearchParams();
  if (from) q.set('from', from);
  if (to) q.set('to', to);
  const query = q.toString();
  return apiClient.get(`app-ratings/stats${query ? `?${query}` : ''}`).then((response) => ({
    ...response,
    mapped: mapFeedbackStats(response?.data),
  }));
};

export const getFeedbackList = (params = {}) =>
  apiClient.get(`app-ratings/feedback?${buildFeedbackQuery(params)}`).then((response) => ({
    ...response,
    mapped: normalizeFeedbackListResponse(response),
  }));

export const getFeedbackUser = (userId) =>
  apiClient.get(`app-ratings/users/${userId}`).then((response) => ({
    ...response,
    mapped: mapFeedbackUser(response?.data),
  }));

export const resolveFeedback = (id, comments) =>
  apiClient.post(`app-ratings/feedback/${id}/resolve`, { comments });

export const dismissFeedback = (id, comments) =>
  apiClient.post(`app-ratings/feedback/${id}/dismiss`, { comments });
